// extracted by mini-css-extract-plugin
export default {"imageCard":"styles_imageCard__1hTXR","label":"styles_label__6zAsj","checked":"styles_checked__rK5O7"};